import React from "react";

export default function ShippingPolicy() {
  return (
    <section style={styles.section}>
      <div style={styles.container}>
        <h1 style={styles.title}>Shipping Policy</h1>

        <h3 style={styles.heading}>Order Processing</h3>
        <p style={styles.text}>
          Orders are processed within 1–2 business days after confirmation.
        </p>

        <h3 style={styles.heading}>Delivery Timeline</h3>
        <p style={styles.text}>
          Delivery typically takes 3–7 business days depending on your location.
        </p>

        <h3 style={styles.heading}>Shipping Charges</h3>
        <p style={styles.text}>
          Shipping charges (if applicable) will be displayed during checkout.
        </p>

        <h3 style={styles.heading}>Tracking</h3>
        <p style={styles.text}>
          Once shipped, customers will receive tracking details via SMS or email.
        </p>

        <h3 style={styles.heading}>Delayed Delivery</h3>
        <p style={styles.text}>
          BioSurge is not responsible for delays caused by courier partners or unforeseen events.
        </p>

        <h3 style={styles.heading}>Address Accuracy</h3>
        <p style={styles.text}>
          Customers must provide accurate shipping details. We are not liable for incorrect addresses.
        </p>
      </div>
    </section>
  );
}

const styles = {
  section:{padding:"60px 20px",background:"#000",minHeight:"100vh"},
  container:{maxWidth:"850px",margin:"0 auto",color:"#ccc"},
  title:{fontSize:"40px",color:"#fff",textAlign:"center",marginBottom:"20px"},
  heading:{color:"#1ac942",marginTop:"25px"},
  text:{lineHeight:"1.7"}
};